import React from 'react'
import { Contributions } from 'Utilities/Plans/ContributionCalculator'
import { AncillaryMemberPremium, TieredRates } from 'Utilities/pharaoh.types'
import PlanTitle from '../plan-subcomponents/PlanTitle'
import { Label } from 'Utilities/config'
import styles from '../ERSupplementalPlans/index.module.scss'
import Plan, { PlanBody } from '../plan-subcomponents/Plan'
import { LifeEEPlan } from 'Components/Plans/LifePlan/index.helpers'
import { isEmployerProps, EmployerProps } from '../plan-subcomponents/PremiumBreakdown'
import EREERate from '../ERSupplementalPlans/ERSupplementalSubComp/EREERate'
import BenifitAmountComp from '../ERSupplementalPlans/ERSupplementalSubComp/BenifitAmountComp'
import PeriodComp from '../ERSupplementalPlans/ERSupplementalSubComp/PeriodComp'
import { GlobalStringConstant } from 'GlobalStringConstant'
import { useToggle } from 'react-use'
import { Group } from 'Utilities/Hooks/useStargate'
import TotalRate from '../ERSupplementalPlans/ERSupplementalSubComp/TotalRate'

interface Props {
  plan: { rate: TieredRates, plan: LifeEEPlan, isRenewal: boolean, memberPremiums?: AncillaryMemberPremium }
  contributions: Contributions
  selected?: boolean
  selectHandler?(plan: LifeEEPlan): void
  label: Label
  stargateGroup?: Group
  showWeeklyPayments: boolean
  showModal: boolean
}

const LifeEE: React.FC< EmployerProps & Props> = ({ plan, selected, selectHandler, label, showWeeklyPayments, contributions, ...props }) => {
  const [showMemberPremiums, toggleShowMemberPremiums] = useToggle(false)
  const sbc = plan.plan.data.sbc
  const dollarAmount = plan.plan.data.benefitAmount ? plan.plan.data.benefitAmount.split(' ')[0].substring(1) : '0'
  const benefitAmountDescriptor = plan.plan.data.benefitAmount.split(/(?<=^\S+)\s/)[1]
  return <Plan selected={!!selected}>

    <PlanTitle
      id={plan.plan.id}
      planName={plan.plan.name}
      carrier={plan.plan.carrier}
      selected={selected}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
      includesProsperBenefits={false}
      planType={plan.plan.type}
      label={label}
      sbc={sbc}
      members={props.members}
      stargateGroup={props.stargateGroup}
      ancillaryMemberPremiums={plan.memberPremiums}
      needsMemberPremiumsShown={true}
      showModal={props.showModal}
      showMemberPremiums={showMemberPremiums}
      toggleShowMemberPremiums={toggleShowMemberPremiums}
    />
    <PlanBody planType={plan.plan.type}>
      {breakdown()}
      <BenifitAmountComp name={GlobalStringConstant[0].benefit_amount} benifitAmount={dollarAmount} benifitLabel={benefitAmountDescriptor}/>
      <div className={`${styles.endSection} ${styles.fourSpecs} ${styles.halfHeight}`}>
        <PeriodComp compName={GlobalStringConstant[0].plan_term} daysOrWeak={plan.plan.data.planTerm} label={' '}/>
        <PeriodComp compName={GlobalStringConstant[0].portability} daysOrWeak={plan.plan.data.portability} label={' '}/>
      </div>
      <div className={styles.planDescFooter}><p><span>*</span>The term life plan rates depend on the age of each employee.</p></div>
    </PlanBody>
  </Plan>

  function breakdown() {
    const base = { plan, contributions, showWeeklyPayments }
    if (isEmployerProps(props)) {
      return <div className={`${styles.beginningSection} ${styles.fourSpecs} ${styles.halfHeight}`}><EREERate {...base} members={props.members}/><TotalRate {...base}/></div>
    }
  }
}

export default LifeEE
